module.exports = __webpack_public_path__ + "static/media/Basal_3011.3b9029b4.jpg";